var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"foo"}}),_c('div',{staticClass:"h-100",attrs:{"id":"root"}},[_c('router-view')],1),_c('LGPDAlert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }